import { render, staticRenderFns } from "./healthcare_market.vue?vue&type=template&id=6809f2f1"
import script from "./healthcare_market.vue?vue&type=script&lang=js"
export * from "./healthcare_market.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports